import { render, staticRenderFns } from "./TradeAdd.vue?vue&type=template&id=01b4c901&"
import script from "./TradeAdd.vue?vue&type=script&lang=js&"
export * from "./TradeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports